export default function Loading() {
  return (
    <div className="w-100 h-100 text-center pt-5">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
